import { flatten, unflatten } from 'flat';
import qs from 'qs';
import * as React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Types } from './duck';

const cleanup = (params: any) => {
  return Object.keys(params).reduce((acc, currentKey) => {
    const value = params[currentKey];
    const isEmptyValue =
      value === '' ||
      value == null ||
      (Array.isArray(value) && value.length === 0);

    return { ...acc, ...(isEmptyValue ? {} : { [currentKey]: value }) };
  }, {});
};

const useQueryParams: Types.UseQueryParams = () => {
  const { search } = useLocation();
  const navigate = useNavigate();

  const params = React.useMemo(() => {
    const currentQuery = search.startsWith('?') ? search.slice(1) : search;
    const parsed: any = qs.parse(currentQuery);
    if (parsed?.pagination?.page != null) {
      parsed.pagination.page = +parsed.pagination.page;
    }
    return parsed;
  }, [search]);

  const setParams = React.useCallback(
    (newParams: Types.QueryParams, props?: { replace: boolean }) => {
      const cleanParams = unflatten(cleanup(flatten(newParams)));
      const newQuery = qs.stringify(cleanParams);
      navigate({ search: newQuery }, { replace: props?.replace || false });
    },
    [navigate]
  );

  return [params, setParams];
};

export default useQueryParams;
